import React from 'react';
import '../../styles/TransportTab.css';

const TransportTab = ({ formData, masterData, onChange }) => {
    const transporters = masterData.transporters || [];
    const carriers = masterData.carriers || [];

    const renderSelect = (field, label, options) => (
        <div className="form-group">
            <label>{label}</label>
            <select
                value={formData[field] || ''}
                onChange={(e) => onChange(field, e.target.value ? parseInt(e.target.value) : null)}
            >
                <option value="">Select {label}</option>
                {options.map(opt => (
                    <option key={opt.id} value={opt.id}>{opt.name}</option>
                ))}
            </select>
        </div>
    );

    const renderInput = (field, label, type = 'text') => (
        <div className="form-group">
            <label>{label}</label>
            <input
                type={type}
                value={formData[field] || ''}
                onChange={(e) => onChange(field, e.target.value)}
            />
        </div>
    );

    const renderTextarea = (field, label, rows = 3) => (
        <div className="form-group full-width">
            <label>{label}</label>
            <textarea
                value={formData[field] || ''}
                onChange={(e) => onChange(field, e.target.value)}
                rows={rows}
            />
        </div>
    );

    return (
        <div className="transport-tab">
            <div className="form-section">
                <h3>Transport Information</h3>
                <div className="form-row">
                    {renderSelect('TransporterID', 'Transporter', transporters)}
                    {renderSelect('CarrierID', 'Carrier', carriers)}
                </div>
                <div className="form-row">
                    {renderInput('TruckRegNo', 'Truck Registration No')}
                    {renderInput('DriverDetails', 'Driver Details')}
                </div>
                <div className="form-row">
                    {renderInput('CollectionDate', 'Collection Date', 'date')}
                    {renderInput('DeliveryDate', 'Delivery Date', 'date')}
                </div>
            </div>

            <div className="form-section">
                <h3>Collection & Delivery</h3>
                <div className="form-row">
                    {renderInput('CollectionPoint', 'Collection Point')}
                    {renderInput('DeliveryPoint', 'Delivery Point')}
                </div>
                <div className="form-row">
                    {renderInput('DeliveryNote', 'Delivery Note No')}
                </div>
            </div>

            <div className="form-section">
                <h3>Instructions</h3>
                {renderTextarea('CollectionInstructions', 'Collection Instructions', 3)}
                {renderTextarea('DeliveryInstructions', 'Delivery Instructions', 3)}
                {renderTextarea('ShippingInstruction', 'Shipping Instructions', 4)}
            </div>

            <div className="form-section">
                <h3>Remarks</h3>
                {renderTextarea('Remarks', 'General Remarks', 5)}
            </div>
        </div>
    );
};

export default TransportTab;